import React from "react";
import MyTab from "./Tab";

const RequestHistory = () => {
  return (
    <div className="mt-[30px]">
      <h2 className="mb-5 text-[15px] font-semibold">Request History</h2>
      <MyTab />
    </div>
  );
};

export default RequestHistory;
